class OrlavenCategoryIndex extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.querySelectorAll('[data-orla-category-reveal]').forEach((item) => item.classList.add('is-visible'));
      return;
    }

    this.classList.add('is-motion-ready');

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          this.observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.18 }
    );

    this.querySelectorAll('[data-orla-category-reveal]').forEach((item) => this.observer.observe(item));
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }
}

if (!customElements.get('orlaven-category-index')) {
  customElements.define('orlaven-category-index', OrlavenCategoryIndex);
}
